import { useState, useEffect, useCallback } from 'react';
import useFetchWithMsal from './useFetchWithMsal';
import { loginRequest, protectedResources } from "../authConfig";
import { ISkillPath } from '../model/SkillPath.model';
import { ISkillLevel } from '../model/SkillLevel.model';

export function useGetTopSkillPathData() {
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [loading, setLoading] = useState(true);
  const [callErr, setErr] = useState(null);
  const [skillPathsTop, setData] = useState(null);


  useEffect(() => {
    if (!skillPathsTop) {
      execute("GET", `/api/SkillPathsTop`)
      .then(response => {
        setData(response);
        setLoading(false);
      }).catch(err => {
        setErr(err);
        setLoading(false);
      })
    }
  }, [execute, skillPathsTop]);
  if (!skillPathsTop) return [null];
  return [skillPathsTop as ISkillPath[], loading, error, callErr];
}


export function useGetSkillPathData(id:string, skillPath:ISkillPath | null, setSkillPath:Function, loading: boolean, setLoading: Function) {
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [callErr, setErr] = useState(null);

    useEffect(() => {
      let skillPathId="-1";
      if (skillPath) skillPathId = (skillPath as any).skillPathId;
      if (!skillPath || skillPathId != id) {
        execute("GET", `/api/SkillPath/${id}`)
        .then(response => {
          setSkillPath(response);
          setLoading(false);
        }).catch(err => {
          setErr(err);
          setLoading(false);
        })
      }
    }, [execute, skillPath, id]);
    if (!skillPath) return [null, true];
    return [error, callErr];
}


export function useUpdateSkillPathData(skillPath:ISkillPath) {
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [loading, setLoading] = useState(true);
  const [callErr, setErr] = useState(null);
  const [skillPathUpdated, setData] = useState(null)


  useEffect(() => {
    let skillPathId="-1";
    if (skillPath) skillPathId = (skillPath as any).skillPathId;
    if (!skillPathUpdated) {
      execute("PUT", `/api/SkillPath/${skillPathId}`, skillPath)
      .then(response => {
        setData(response);
        setLoading(false);
      }).catch(err => {
        setErr(err);
        setLoading(false);
      })
    }
  }, [execute, skillPath, skillPathUpdated]);
  return [skillPathUpdated, loading, error, callErr];
}